'use es6';

import PropTypes from 'prop-types';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PersonaCountLabel = ({
  count,
  total
}) => {
  const countNode = count === 0 ? '—' : /*#__PURE__*/_jsx(FormattedNumber, {
    value: count
  });
  const percentage = /*#__PURE__*/_jsx(FormattedPercentage, {
    value: count / total * 100,
    precision: 2
  });
  return /*#__PURE__*/_jsxs("span", {
    children: [countNode, " (", percentage, ")"]
  });
};
PersonaCountLabel.propTypes = {
  count: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};
export default PersonaCountLabel;